import styled from "@emotion/styled"
// import styled from "styled-components"; // You need this as well
// import media from "styled-media-query";
import { AiFillLinkedin, AiFillGithub, AiFillMail } from "react-icons/ai";
import { HiDownload } from "react-icons/hi";
// import "../styles/home.css" 

export const Home = () => {
    const Opentab = () => {
        window.open("/pdf/amir_khan_resume.pdf", "_blank")
    }
    return (
        <DIV id="home">
            <div>
                <img src="https://i.ibb.co/L1Ls2sf/developer.png" alt="developer" border="0" />
            </div>
            <div>
                <h1>Hi there! I'm Amir Khan</h1>
                <p>Full Stack Web Developer</p>
                <p>Aspiring Full Stack Web Developer Skilled in MERN stack with hands-on experience in developing scalable websites using a wide range of Front-end and Back-end skills like HTML, CSS, JavaScript, React, MongoDB, and Node JS. Looking forward to joining a progressive organization with opportunities to work on challenging projects.</p>
                <div>
                    <a href="/pdf/amir_khan_resume.pdf" download>
                        <button className="download_resume" onClick={Opentab}>Resume
                            <HiDownload></HiDownload>
                        </button>
                    </a>
                    <a href="https://www.linkedin.com/in/amir-khan-5a6171199">
                        <AiFillLinkedin className="icon"></AiFillLinkedin>

                    </a>
                    <a href="https://github.com/amir241297">
                        <AiFillGithub className="icon"></AiFillGithub>
                    </a>
                    <a href="https://mail.google.com/mail/u/1/#inbox?compose=new">
                        <AiFillMail className="icon"></AiFillMail>
                    </a>
                </div>
            </div>


        </DIV>
    )
} 
const DIV = styled.div`
h1+p{
    color: #63aef0;

}
    @media (max-width: 480px) {
    /* screen width is less than 480px (Phone) */
    display: flex;
    flex-direction: column;
    margin-top: 100px;
    width: 100%;
    padding: 7%;

     div:nth-child(1){
        width: 60%;
        margin: auto;
        margin-bottom: 50px;
        padding: 3%;
    }
    img{
        width: 100%;
        border-radius: 20%;
        padding: 3%;
        
    }
    h1{
        font-size: 30px;
        margin-bottom: 15px;
        font-weight: 500;
    }
    h1+p{
        font-size: 25px;
        /* color: #63aef0; */
        font-weight: 500;

    }
    p{
        font-size:17px ;
        font-weight: 400;
        margin-bottom: 10px;
    }
    div:nth-child(2)>div{
        display: flex;
        justify-content: space-around;
        align-items: center;
        width: 80%;
        margin: auto;
        margin-top: 30px;
    }
    .icon{
        font-size: 35px;
    }
    .download_resume{
        display: flex;
        justify-content: space-evenly;
        align-items: center;
        height: 40px;
        width: 130px;
        background-color:rgb(223, 23, 173);
        border-radius:10px;
        font-size: 18px;
        font-weight:500;
        color: black;
    }
 
  }

  @media (min-width: 481px) and (max-width: 768px) {
    /* screen width is between 481px (medium) and 768px (IPad) */
    display: flex;
    flex-direction: column;
    margin-top: 100px;
    width: 100%;
    padding: 7%;

     div:nth-child(1){
        width: 60%;
        margin: auto;
        margin-bottom: 50px;
        padding: 3%;
    }
    h1{
        font-size: 35px;
        margin-bottom: 15px;
        font-weight: 500;
    }
    h1+p{
        font-size: 25px;
        /* color: #bbd5ec; */
        font-weight: 500;

    }
    p{
        font-size:22px ;
        font-weight: 400;
        margin-bottom: 10px;
    }
    img{
        width: 100%;
        border-radius: 20%;
        padding: 3%;
        
    }
    div:nth-child(2)>div{
        display: flex;
        justify-content: space-around;
        align-items: center;
        width: 80%;
        margin: auto;
        margin-top: 30px;
    }
    .icon{
        font-size: 30px;
    }
    .download_resume{
        display: flex;
        justify-content: space-evenly;
        align-items: center;
        height: 40px;
        width: 130px;
        background-color:rgb(223, 23, 173);
        border-radius:10px;
        font-size: 18px;
        font-weight:500;
        color: black;
    }
 
  
}

  @media (min-width: 769px) and (max-width: 1200px) {
    /* screen width is between 769px (medium) and 1024px (large) (Tablet)*/
    display: flex;
    flex-direction: column;
    margin-top: 100px;
    width: 100%;
    padding: 7%;
    div:nth-child(1){
        width: 50%;
        margin: auto;
        margin-bottom: 50px;
        padding: 3%;
    }
    h1{
        font-size: 50px;
        margin-bottom: 15px;
        font-weight: 500;
    }
    h1+p{
        font-size: 40px;
        font-weight: 500;

        /* color: #bbd5ec; */
    }
    p{
        font-size:25px ;
        font-weight: 400;
        margin-bottom: 10px;
    }
    div:nth-child(2)>div{
        display: flex;
        justify-content: space-around;
        align-items: center;
        width: 80%;
        margin: auto;
        margin-top: 30px;
    }
    .icon{
        font-size: 40px;
    }
    img{
        width: 100%;
        border-radius: 20%;
        padding: 3%;
        
    }
    .download_resume{
        display: flex;
        justify-content: space-evenly;
        align-items: center;
        height: 40px;
        width: 130px;
        background-color:rgb(223, 23, 173);
        border-radius:10px;
        font-size: 18px;
        font-weight:500;
        color: black;
    }
  }
 
  @media (min-width: 1201px){ 
    /* screen width is greater than 1200px (large) */


    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
    width: 70%;
    margin: auto;
    margin-top: 150px; 
    
    div:nth-child(1){
        width: 40%;
        padding: 3%;

    }
    h1{
        font-size: 40px;
        margin-bottom: 15px;
        font-weight: 500;
    }
    h1+p{
        font-size: 25px;
        font-weight: 500;
        /* color: #bbd5ec; */
    }
    p{
        font-size:22px ;
        font-weight: 400;
        margin-bottom: 10px;
    }
    div:nth-child(2)>div{
        display: flex;
        justify-content: space-around;
        align-items: center;
        width: 50%;
        margin: auto;
        margin-top: 30px;
    }
    
    div:nth-child(2){
        width: 60%;
    }
    img{
        width: 100%;
        border-radius: 20%;
        padding: 3%;
        
    }
    .icon{
        font-size: 30px;
    }
    .download_resume{
        display: flex;
        justify-content: space-evenly;
        align-items: center;
        height: 40px;
        width: 130px;
        background-color:rgb(223, 23, 173);
        border-radius:10px;
        font-size: 18px;
        font-weight:500;
        color: black;
    }
  }
`